import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import MenuItem from '@material-ui/core/MenuItem';

import WrappedSelectField from 'components/WrappedSelectField/WrappedSelectField';

const propTypes = {
  input: PropTypes.shape({ name: PropTypes.string }),
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  availablePlans: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })).isRequired,
  selectedService: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  trackButtonClick: PropTypes.func.isRequired,
  availablePlansInfo: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const defaultProps = {
  input: {},
  className: '',
  isDisabled: false,
};

export function UnstyledPlanSelect({
  className,
  name,
  availablePlans,
  isDisabled,
  selectedService,
  trackButtonClick,
  availablePlansInfo,
}) {
  const label = 'Total Capacity';

  const menuLabel = (
    <MenuItem key="label" value="" disabled>
      <em>{label}</em>
    </MenuItem>
  );

  let planList = availablePlansInfo.map((availablePlanInfo) => {
    return (
      <MenuItem key={availablePlanInfo.planId} value={availablePlanInfo.planId}>
        {availablePlanInfo.sizeInfo}
      </MenuItem>
    );
  });

  planList = [menuLabel, ...planList];

  return (
    <Field
      className={className}
      name={name}
      component={WrappedSelectField}
      label={label}
      disabled={isDisabled}
      onChange={(e) => {
        trackButtonClick(
          selectedService.concat(' ', availablePlans.find((x) => x.id === e.target.value).name),
        );
      }}
    >
      {planList}
    </Field>
  );
}

UnstyledPlanSelect.propTypes = propTypes;
UnstyledPlanSelect.defaultProps = defaultProps;

export default reduxForm({
  form: 'create',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(UnstyledPlanSelect);
